import { gql } from '@apollo/client';

export default gql`
  mutation createInspectionSubject(
    $name: String!
    $brand: String
    $model: String
    $serialNumber: String
    $placeId: ID!
    $notes: String
  ) {
    createInspectionSubject(
      input: {
        name: $name
        brand: $brand
        model: $model
        serialNumber: $serialNumber
        placeId: $placeId
        notes: $notes
      }
    ) {
      inspectionSubject {
        id
        name
        brand
        model
        serialNumber
        place {
          id
        }
      }
    }
  }
`;
